var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPersonChat = function SvgPersonChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "currentColor"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "person_chat_svg__a",
    width: 25,
    height: 25,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.413.272h24v24h-24z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#person_chat_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.413 14.273h8v-.55q0-1.1-1.1-1.776-1.1-.674-2.9-.674t-2.9.675-1.1 1.774zm4-4q.824 0 1.412-.588t.588-1.413q0-.824-.588-1.412a1.93 1.93 0 0 0-1.412-.588q-.825 0-1.413.588a1.93 1.93 0 0 0-.587 1.412q0 .825.587 1.413.588.588 1.413.588m-10 12v-18q0-.825.587-1.413a1.93 1.93 0 0 1 1.413-.588h16q.824 0 1.412.588t.588 1.412v12q0 .825-.588 1.413a1.93 1.93 0 0 1-1.412.588h-14zm3.15-6h14.85v-12h-16v13.125z"
  }))));
};
export default SvgPersonChat;